/* Virtumaq - Consultor (v0.2) - versao para o TEMA. Codigo original. */
(function () {
  'use strict';
  if (window.VQC) return;

  window.VQC = {
    mod: {},
    config: {
      whatsapp: '5551996224082',

      // true = MODO DE TESTE: nada e enviado ao Meta nem ao GA4.
      dryRun: false,

      rotuloBotao: 'Falar com um consultor',

      modulos: {
        cards: true,
        categorias: true,
        videoHome: true,
        pdp: true
      },

      seletores: {
        card: '.product-item',
        titulo: '.product-item__title',
        area: '.product-item__info-inner',
        categoria: 'a.collection-item',
        pdpRaiz: 'main',
        pdpTitulo: 'h1',
        pdpForm: '.product-form',
        pdpVideo: '.video-wrapper'
      },

      parcelas: { corrigir: true, qtd: 12, fator: 0.10134142259414225 },

      confianca: ['Pronta entrega', 'Teste no showroom', 'Em até 12x']
    }
  };
})();
/* Base compartilhada: rota, observador do DOM, botao de WhatsApp e medicao de cliques. */
(function () {
  'use strict';
  var V = window.VQC;
  if (!V || V.mod.base) return;
  V.mod.base = true;
  var CFG = V.config;

  var ICONE =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 1.8a8.2 8.2 0 0 1 0 16.4c-1.4 0-2.7-.4-3.9-1l-.3-.2-2.9.8.8-2.8-.2-.3A8.2 8.2 0 0 1 12 3.8zm-3 4.3c-.2 0-.5.1-.7.4-.3.3-1 1-1 2.4s1 2.800 1.200 3c.1.200 2 3.100 4.900 4.300 2.400 1 2.900.8 3.400.7.500-.1 1.700-.7 1.900-1.400.2-.7.2-1.200.2-1.400-.1-.1-.3-.2-.6-.4l-1.900-.9c-.3-.1-.5-.1-.7.1l-.9 1.100c-.2.200-.3.200-.6.100-.3-.1-1.200-.4-2.300-1.400-.8-.8-1.400-1.700-1.600-2-.2-.3 0-.4.100-.6l.4-.5c.1-.2.200-.3.300-.5.100-.2 0-.4 0-.5l-.9-2.100c-.2-.5-.5-.5-.7-.5H9z"/></svg>';

  V.icone = ICONE;
  V.qsa = function (sel, raiz) {
    return Array.prototype.slice.call((raiz || document).querySelectorAll(sel));
  };

  V.rota = function () {
    var p = window.location.pathname.replace(/\/+$/, '') || '/';
    if (p === '/') return 'home';
    if (/\/products\/[^/]+/.test(p)) return 'produto';
    if (/\/collections(\/|$)/.test(p)) return 'colecao';
    return 'outra';
  };

  V.brl = function (n) {
    return 'R$ ' + Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  V.brlInteiro = function (n) {
    return 'R$ ' + Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  };

  var ouvintes = [];
  var agendado = false;
  function rodar() {
    agendado = false;
    for (var i = 0; i < ouvintes.length; i++) {
      try { ouvintes[i](); } catch (e) { console.warn('[Virtumaq Consultor] modulo falhou:', e); }
    }
  }
  function agendar() {
    if (agendado) return;
    agendado = true;
    window.requestAnimationFrame(rodar);
  }
  V.aoMudar = function (fn) {
    ouvintes.push(fn);
    try { fn(); } catch (e) { console.warn('[Virtumaq Consultor] modulo falhou:', e); }
  };
  new MutationObserver(agendar).observe(document.body, { childList: true, subtree: true, characterData: true });

  var toastEl = null;
  var toastTimer = null;
  V.avisar = function (texto) {
    if (!CFG.dryRun) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'vqc-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = texto;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3500);
  };

  V.linkWa = function (texto) {
    return 'https://wa.me/' + CFG.whatsapp + '?text=' + encodeURIComponent(texto);
  };

  V.criarCta = function (opts) {
    var a = document.createElement('a');
    a.className = opts.classe || 'vqc-cta';
    a.target = '_blank';
    a.rel = 'noopener';
    a.href = V.linkWa(opts.texto);
    a.setAttribute('data-vqc-origem', opts.origem || 'outro');
    if (opts.produto) a.setAttribute('data-vqc-produto', opts.produto);
    a.innerHTML = ICONE + '<span></span>';
    a.lastChild.textContent = opts.rotulo || CFG.rotuloBotao;
    return a;
  };

  function ehLinkWhatsApp(a) {
    return !!a && /^(https?:\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)|whatsapp:)/i.test(a.getAttribute('href') || '');
  }

  function origemDoLink(a) {
    var marcada = a.getAttribute('data-vqc-origem');
    if (marcada) return marcada;
    if (a.closest('.wa-float-btn, [class*="wa-float" i], [class*="whatsapp" i], [id*="whatsapp" i]')) return 'botao_flutuante';
    return 'outro';
  }

  var ultimo = { chave: '', quando: 0 };

  function registrar(a) {
    var produto = a.getAttribute('data-vqc-produto') || '';
    var origem = origemDoLink(a);
    var destino = (a.getAttribute('href') || '').split('?')[0];

    var chave = origem + '|' + produto + '|' + destino;
    var agora = Date.now();
    if (ultimo.chave === chave && agora - ultimo.quando < 1000) return;
    ultimo = { chave: chave, quando: agora };

    var dados = { method: 'whatsapp', origem: origem, produto: produto, pagina: window.location.pathname };

    if (CFG.dryRun) {
      console.info('[Virtumaq Consultor] TESTE, evento nao enviado:', dados);
      V.avisar('Teste: clique no WhatsApp registrado (' + origem + (produto ? ': ' + produto : '') + ')');
      return;
    }

    var camada = (window.dataLayer = window.dataLayer || []);
    camada.push({ event: 'whatsapp_click', whatsapp_origem: origem, whatsapp_produto: produto });

    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Contact', { content_name: produto || undefined, content_category: origem });
      }
    } catch (e) {}

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', { method: 'whatsapp', item_name: produto || undefined, lead_source: origem });
      }
    } catch (e) {}
  }

  document.addEventListener('click', function (ev) {
    var alvo = ev.target;
    var a = alvo && alvo.closest ? alvo.closest('a[href]') : null;
    if (a && ehLinkWhatsApp(a)) registrar(a);
  }, true);

  if (CFG.dryRun) {
    console.info('[Virtumaq Consultor] ativo em MODO DE TESTE (dryRun). Nada e enviado aos pixels.');
  }
})();
/* Modulo: botao em cada card de produto. */
(function () {
  'use strict';
  var V = window.VQC;
  if (!V || V.mod.cards || !V.config.modulos.cards) return;
  V.mod.cards = true;
  var S = V.config.seletores;

  function criar(card) {
    if (card.getAttribute('data-vqc') === '1') return;
    var titulo = card.querySelector(S.titulo);
    var area = card.querySelector(S.area);
    if (!titulo || !area) return;

    var nome = (titulo.textContent || '').replace(/\s+/g, ' ').trim();
    if (!nome) return;
    var url = titulo.href || window.location.href;

    area.appendChild(V.criarCta({
      classe: 'vqc-cta',
      origem: 'card',
      produto: nome,
      texto: 'Olá! Tenho interesse na ' + nome + ' e gostaria de falar com um consultor. ' + url
    }));
    card.setAttribute('data-vqc', '1');
  }

  V.aoMudar(function () { V.qsa(S.card).forEach(criar); });
})();

/* Modulo: categorias da home com mais destaque. */
(function () {
  'use strict';
  var V = window.VQC;
  if (!V || V.mod.categorias || !V.config.modulos.categorias) return;
  V.mod.categorias = true;
  var S = V.config.seletores;

  var reduzir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  if (!reduzir && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (itens) {
      itens.forEach(function (it) {
        if (it.isIntersecting) {
          it.target.classList.add('vqc-in');
          io.unobserve(it.target);
        }
      });
    }, { threshold: 0.15 });
  }

  function melhorar(a, indice) {
    if (a.getAttribute('data-vqc-cat')) return;
    a.setAttribute('data-vqc-cat', '1');
    a.classList.add('vqc-cat');

    var chip = document.createElement('span');
    chip.className = 'vqc-cat__chip';
    chip.textContent = 'Ver máquinas';
    chip.setAttribute('aria-hidden', 'true');
    a.appendChild(chip);

    if (io) {
      a.classList.add('vqc-pre');
      a.style.transitionDelay = Math.min(indice, 6) * 60 + 'ms';
      io.observe(a);
      setTimeout(function () { a.classList.add('vqc-in'); }, 2500);
    }
  }

  function ajuda(categorias) {
    var ultima = categorias[categorias.length - 1];
    var secao = ultima.closest('.shopify-section') || ultima.parentElement;
    if (!secao || secao.getAttribute('data-vqc-ajuda')) return;
    secao.setAttribute('data-vqc-ajuda', '1');

    var caixa = document.createElement('div');
    caixa.className = 'vqc-cat-ajuda';
    var txt = document.createElement('p');
    txt.textContent = 'Não sabe qual máquina serve para o seu trabalho?';
    caixa.appendChild(txt);
    caixa.appendChild(V.criarCta({
      classe: 'vqc-cta vqc-cta--inline',
      origem: 'home_categorias',
      texto: 'Olá! Estou vendo as categorias no site e preciso de ajuda para escolher a máquina a laser certa.'
    }));
    secao.insertAdjacentElement('afterend', caixa);
  }

  V.aoMudar(function () {
    if (V.rota() !== 'home' || window.matchMedia('(max-width: 768px)').matches) return;
    var lista = V.qsa(S.categoria).filter(function (a) { return !a.closest('header, footer, nav'); });
    if (!lista.length) return;
    lista.forEach(melhorar);
    ajuda(lista);
  });
})();

/* Modulo: secao de videos da home. */
(function () {
  'use strict';
  var V = window.VQC;
  if (!V || V.mod.videoHome || !V.config.modulos.videoHome) return;
  V.mod.videoHome = true;

  var SELETOR = 'video, iframe[src*="youtube"], iframe[src*="youtu.be"], iframe[src*="vimeo"]';
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (itens) {
      itens.forEach(function (it) {
        var v = it.target;
        if (it.isIntersecting && it.intersectionRatio >= 0.5) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: [0, 0.5, 1] });
  }

  function botaoSom(video) {
    var pai = video.parentElement;
    if (!pai || pai.querySelector('.vqc-som')) return;
    if (window.getComputedStyle(pai).position === 'static') pai.style.position = 'relative';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'vqc-som';
    var atualizar = function () {
      b.textContent = video.muted ? 'Ativar som' : 'Desativar som';
      b.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
    };
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      video.muted = !video.muted;
      atualizar();
    });
    atualizar();
    pai.appendChild(b);
  }

  function preparar(video) {
    if (video.getAttribute('data-vqc-vid')) return;
    video.setAttribute('data-vqc-vid', '1');
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.loop = true;
    if (!video.hasAttribute('controls')) botaoSom(video);
    if (io) io.observe(video);
  }

  function convite(secao) {
    var caixa = document.createElement('div');
    caixa.className = 'vqc-video-cta';
    var txt = document.createElement('p');
    txt.textContent = 'Viu a máquina funcionando? Um consultor tira suas dúvidas e indica o modelo certo.';
    caixa.appendChild(txt);
    caixa.appendChild(V.criarCta({
      classe: 'vqc-cta vqc-cta--inline',
      origem: 'home_video',
      texto: 'Olá! Vi o vídeo da máquina no site e gostaria de falar com um consultor.'
    }));
    secao.insertAdjacentElement('afterend', caixa);
  }

  V.aoMudar(function () {
    if (V.rota() !== 'home' || window.matchMedia('(max-width: 768px)').matches) return;
    V.qsa(SELETOR).forEach(function (el) {
      if (el.closest('header, footer, nav, [class*="popup" i], [class*="modal" i], [class*="drawer" i]')) return;
      var secao = el.closest('.shopify-section') || el.parentElement;
      if (!secao) return;
      if (el.tagName === 'VIDEO') preparar(el);
      if (!secao.getAttribute('data-vqc-video')) {
        secao.setAttribute('data-vqc-video', '1');
        convite(secao);
      }
    });
  });
})();
/* Modulo: pagina de produto (PDP). */
(function () {
  'use strict';
  var V = window.VQC;
  if (!V || V.mod.pdp || !V.config.modulos.pdp) return;
  V.mod.pdp = true;
  var CFG = V.config;
  var S = CFG.seletores;

  function nomeProduto() {
    var h = document.querySelector(S.pdpRaiz + ' ' + S.pdpTitulo) || document.querySelector(S.pdpTitulo);
    return h ? (h.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function paraNumero(txt) {
    if (!txt) return 0;
    txt = String(txt).trim();
    if (txt.indexOf(',') > -1 && txt.indexOf('.') === -1) txt = txt.replace(',', '.');
    else txt = txt.replace(/,/g, '');
    var n = parseFloat(txt);
    return isFinite(n) ? n : 0;
  }

  function preco() {
    try {
      var A = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var prod = A && A.product;
      if (prod && prod.variants && prod.variants.length) {
        var id = A.selectedVariantId || new URLSearchParams(window.location.search).get('variant');
        var v = null;
        for (var i = 0; i < prod.variants.length; i++) {
          if (String(prod.variants[i].id) === String(id)) { v = prod.variants[i]; break; }
        }
        v = v || prod.variants[0];
        if (v && v.price > 0) return v.price / 100;
      }
    } catch (e) {}
    var og = document.querySelector('meta[property="og:price:amount"], meta[property="product:price:amount"]');
    return og ? paraNumero(og.getAttribute('content')) : 0;
  }

  function urlLimpa() {
    return window.location.origin + window.location.pathname;
  }

  var avisouCorrecao = false;
  function corrigirParcelas() {
    var P = CFG.parcelas;
    if (!P || !P.corrigir) return;
    var p = preco();
    if (!p) return;
    var valor = V.brl(p * P.fator);

    var raiz = document.querySelector(S.pdpRaiz) || document.body;
    var mudou = 0;

    var walker = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null);
    var no;
    var alvos = [];
    while ((no = walker.nextNode())) {
      if (/\d{1,2}\s*x\s+de\s+R\$\s*0,00/i.test(no.nodeValue)) alvos.push(no);
    }
    alvos.forEach(function (n) {
      n.nodeValue = n.nodeValue.replace(/(\d{1,2}\s*x\s+de\s+)R\$\s*0,00/i, '$1' + valor);
      mudou++;
    });

    V.qsa('*', raiz).forEach(function (el) {
      if (el.children.length) return;
      if (!/^\s*R\$\s*0,00\s*$/.test(el.textContent)) return;
            var pai = el.parentElement;
      var avo = pai && pai.parentElement;
      if (/\d{1,2}\s*x\s*de/i.test((pai ? pai.textContent : '') + ' ' + (avo ? avo.textContent : ''))) {
        el.textContent = valor;
        mudou++;
      }
    });

    if (mudou && !avisouCorrecao) {
      avisouCorrecao = true;
      console.info('[Virtumaq Consultor] parcela corrigida na pagina de produto (' + P.qtd + 'x de ' + valor + ').');
    }
  }

  function caixaPrincipal() {
    var form = document.querySelector(S.pdpForm);
    if (!form || document.querySelector('.vqc-pdp')) return null;
    var nome = nomeProduto();
    var p = preco();

    var caixa = document.createElement('div');
    caixa.className = 'vqc-pdp';

    var texto = 'Olá! Tenho interesse na ' + (nome || 'máquina a laser') +
      (p ? ' (' + V.brlInteiro(p) + ')' : '') + ' e gostaria de falar com um consultor. ' + urlLimpa();

    var cta = V.criarCta({
      classe: 'vqc-cta vqc-cta--grande',
      origem: 'pdp_principal',
      produto: nome,
      rotulo: 'Falar com um consultor agora',
      texto: texto
    });
    caixa.appendChild(cta);

    var sub = document.createElement('p');
    sub.className = 'vqc-pdp__sub';
    sub.textContent = 'Tire dúvidas, veja condições e peça uma demonstração.';
    caixa.appendChild(sub);

    if (CFG.confianca && CFG.confianca.length) {
      var ul = document.createElement('ul');
      ul.className = 'vqc-pdp__selos';
      CFG.confianca.forEach(function (t) {
        var li = document.createElement('li');
        li.textContent = t;
        ul.appendChild(li);
      });
      caixa.appendChild(ul);
    }

    form.insertAdjacentElement('afterend', caixa);
    return cta;
  }

  function atalhoVideo() {
    var video = document.querySelector(S.pdpVideo);
    var titulo = document.querySelector(S.pdpRaiz + ' ' + S.pdpTitulo) || document.querySelector(S.pdpTitulo);
    if (!video || !titulo || document.querySelector('.vqc-pdp-video')) return;
    var a = document.createElement('a');
    a.className = 'vqc-pdp-video';
    a.href = '#';
    a.textContent = 'Ver a máquina funcionando';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      video.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    titulo.insertAdjacentElement('afterend', a);
  }

  var barra = null;
  var precoBarra = null;

  function montarBarra() {
    if (barra) return;
    var nome = nomeProduto();
    barra = document.createElement('div');
    barra.className = 'vqc-sticky';
    barra.setAttribute('aria-hidden', 'true');

    var info = document.createElement('div');
    info.className = 'vqc-sticky__info';
    precoBarra = document.createElement('strong');
    info.appendChild(precoBarra);
    var parc = document.createElement('span');
    info.appendChild(parc);
    barra._parc = parc;
    barra.appendChild(info);

    barra.appendChild(V.criarCta({
      classe: 'vqc-cta vqc-cta--sticky',
      origem: 'pdp_sticky',
      produto: nome,
      rotulo: 'Consultor',
      texto: 'Olá! Tenho interesse na ' + (nome || 'máquina a laser') + ' e gostaria de falar com um consultor. ' + urlLimpa()
    }));
    document.body.appendChild(barra);
  }

  function atualizarBarra() {
    if (!barra) return;
    var p = preco();
    precoBarra.textContent = p ? V.brlInteiro(p) : '';
    barra._parc.textContent = p && CFG.parcelas ? 'ou ' + CFG.parcelas.qtd + 'x de ' + V.brl(p * CFG.parcelas.fator) : '';
  }

  function observarBotao(cta) {
    if (!cta || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (itens) {
      var it = itens[0];
      var passou = !it.isIntersecting && it.boundingClientRect.top < 0;
      document.body.classList.toggle('vqc-sticky-on', passou);
      if (barra) barra.setAttribute('aria-hidden', passou ? 'false' : 'true');
    }, { threshold: 0 }).observe(cta);
  }

  var iniciado = false;
  V.aoMudar(function () {
    if (V.rota() !== 'produto') return;
    corrigirParcelas();
    if (!iniciado) {
      var cta = caixaPrincipal();
      if (cta) {
        iniciado = true;
        atalhoVideo();
        montarBarra();
        observarBotao(document.querySelector(S.pdpForm) || cta);
      }
    }
    atualizarBarra();
  });
})();
/* Teste: videos do YouTube na home (circulo Brindes + card Fiber 30W). Escrito do zero. */
(function () {
'use strict';
if (!(location.pathname === '/' || location.pathname === '')) return;
var ALVOS = [
  { seletor: '.product-item a[href*="fiber-laser-30w"]', video: 'yS4mIS4yZs8', vert: true, titulo: 'Fiber Laser 30W' },
];
function montar(caixa, alvo) {
if (!alvo || caixa.querySelector('.vqc-cardvideo')) return;
var d = document.createElement('div');
d.className = 'vqc-cardvideo' + (alvo.vert ? ' vqc-cardvideo--vert' : '');
d.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + alvo.video + '?autoplay=1&mute=1&controls=0&loop=1&playlist=' + alvo.video + '&rel=0&playsinline=1&modestbranding=1&disablekb=1&iv_load_policy=3" title="' + alvo.titulo + '" allow="autoplay; encrypted-media" tabindex="-1"></iframe>';
caixa.appendChild(d);
}
var io = new IntersectionObserver(function (ents) {
ents.forEach(function (ent) {
if (!ent.isIntersecting) return;
io.unobserve(ent.target);
montar(ent.target, ent.target.vqcAlvo);
});
}, { rootMargin: '200px 0px' });
function varrer() {
ALVOS.forEach(function (alvo) {
document.querySelectorAll(alvo.seletor).forEach(function (el) {
var base = el.closest('.product-item') || el;
var caixa = base.querySelector('.aspect-ratio') || base.querySelector('.collection-item__image-wrapper') || base.querySelector('.product-item__image-wrapper');
if (!caixa || caixa.querySelector('.vqc-cardvideo')) return;
caixa.vqcAlvo = alvo;
io.observe(caixa);
});
});
}
if (document.readyState === 'complete') {
varrer();
} else {
window.addEventListener('load', varrer);
}
setTimeout(varrer, 3000);
setTimeout(varrer, 8000);
})();
